import {Component, EnvironmentInjector, Input, OnDestroy, OnInit} from '@angular/core';
import {RouterModule} from '@angular/router';
import {ConnectHelper} from '../../utils/connect-helper';
import {ConfigService, SDKMode} from '@shared-library';
import {CommonModule} from "@angular/common";
import {Subscription} from "rxjs";
import {
  FdkButtonComponent,
  FdkIllustrationComponent,
} from 'fasten-design-kit';

@Component({
    selector: 'app-health-system-connecting',
    templateUrl: './health-system-connecting.component.html',
    styleUrls: ['./health-system-connecting.component.css'],
    standalone: true,
    imports: [
      CommonModule,
      RouterModule,
      FdkButtonComponent,
      FdkIllustrationComponent,
    ]
})
export class HealthSystemConnectingComponent implements OnInit, OnDestroy {
  @Input() brandId: string = "";
  @Input() portalId: string = "";
  @Input() endpointId: string = "";

  @Input() externalId?: string = "";
  @Input() externalState?: string = "";

  @Input() orgConnectionId?: string = ""; //required if reconnecting an existing source
  @Input() vaultProfileConnectionId?: string = ""; //required if reconnecting an existing vault profile connection id

  @Input() sdkMode?: SDKMode = SDKMode.None; //default is SDKMode.None, can be set to SDKMode.ReactNative or others

  private connectHelperSubscription: Subscription;

  constructor(
    public configService: ConfigService,
    private injector: EnvironmentInjector
  ){}

  ngOnDestroy() {
    //this is required because in websocket mode, this subscription remains active until unsubscribed.
    if(this.connectHelperSubscription){
      this.connectHelperSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {

    this.injector.runInContext(() => {
      this.connectHelperSubscription = ConnectHelper({
        public_id: this.configService.systemConfig$.publicId,
        brand_id: this.brandId,
        portal_id: this.portalId,
        endpoint_id: this.endpointId,
        org_connection_id: this.orgConnectionId,
        external_id: this.externalId,
        external_state: this.externalState,
        vault_profile_connection_id: this.vaultProfileConnectionId,
        connect_mode: this.configService.systemConfig$.connectMode,
      })
    })
  }

}
